import { InjectionToken } from '@angular/core';

export const ENABLED_AUTH_PROVIDERS = new InjectionToken<AuthProvider[]>('ENABLED_AUTH_PROVIDERS');

export enum AuthProvider {
  EMAIL = 'email',
  GOOGLE = 'google',
  MICROSOFT = 'microsoft',
  /** SMS code sign-in; the driver app only. */
  PHONE = 'phone',
}
